import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FbModuleComponent } from './fb-module.component';
import { FbModuleRoutingModule } from './fb-module-routing.module';
import { FbHeaderComponent } from './fb-header/fb-header.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { FbPageTitleParentActionButtonComponent } from './fb-page-title-parent-action-button/fb-page-title-parent-action-button.component';
import { FbSimpleFormComponent } from './fb-simple-form/fb-simple-form.component';
import { VisaDesignerModule } from '../visa-designer/visa-designer.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MasterListTableComponent } from './master-list-table/master-list-table.component';
import { FbContainerComponent } from './fb-container/fb-container.component';
import { FbVerticalTabComponent } from './fb-vertical-tab/fb-vertical-tab.component';
import { FbPopUpSimpleFormComponent } from './fb-pop-up-simple-form/fb-pop-up-simple-form.component';
import { FbDashboardComponent } from './fb-dashboard/fb-dashboard.component';
import { FbDashboardSmallTilesComponent } from './fb-dashboard-small-tiles/fb-dashboard-small-tiles.component';
import { FbLeaveApprovalStatusDashboardCardComponent } from './fb-leave-approval-status-dashboard-card/fb-leave-approval-status-dashboard-card.component';
import { FbSummaryStatusDasboardCardComponent } from './fb-summary-status-dasboard-card/fb-summary-status-dasboard-card.component';
import { FbNotificationsDashboardCardComponent } from './fb-notifications-dashboard-card/fb-notifications-dashboard-card.component';
import { FbAnnouncementsDashboardCardComponent } from './fb-announcements-dashboard-card/fb-announcements-dashboard-card.component';
import { FbTeamMembersDashboardCardComponent } from './fb-team-members-dashboard-card/fb-team-members-dashboard-card.component';
import { FbHolidayListDashboardCardComponent } from './fb-holiday-list-dashboard-card/fb-holiday-list-dashboard-card.component';
import { FbTableListDashboardCardComponent } from './fb-table-list-dashboard-card/fb-table-list-dashboard-card.component';
import { FbOnboardingChecklistDashboardCardComponent } from './fb-onboarding-checklist-dashboard-card/fb-onboarding-checklist-dashboard-card.component';
import { FbComingSoonDashboardCardComponent } from './fb-coming-soon-dashboard-card/fb-coming-soon-dashboard-card.component';
import { FbAttendenceDashboardCardComponent } from './fb-attendence-dashboard-card/fb-attendence-dashboard-card.component';
import { MarkInOutModule } from 'mark-in-out';
import { FbMultiStepFormComponent } from './fb-multi-step-form/fb-multi-step-form.component';
import { FbHorizontalTabComponent } from './fb-horizontal-tab/fb-horizontal-tab.component';
import { FbDashboardQuickAccessComponent } from './fb-dashboard-quick-access/fb-dashboard-quick-access.component';
import { FbMarginGrowthCardComponent } from './fb-margin-growth-card/fb-margin-growth-card.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatDialogModule } from "@angular/material/dialog";
import { FbRedirectPopupComponent } from './fb-redirect-popup/fb-redirect-popup.component';


@NgModule({
  imports: [
    CommonModule,
    FbModuleRoutingModule,
    MatBadgeModule,
    MatMenuModule,
    MatIconModule,
    SharedModule,
    VisaDesignerModule,
    ReactiveFormsModule,
    MarkInOutModule,
    HighchartsChartModule,
    MatDialogModule
  ],
  declarations: [
    FbModuleComponent,
    FbHeaderComponent,
    FbPageTitleParentActionButtonComponent,
    FbSimpleFormComponent,
    MasterListTableComponent,
    FbContainerComponent,
    FbVerticalTabComponent,
    FbPopUpSimpleFormComponent,
    FbDashboardComponent,
    FbDashboardSmallTilesComponent,
    FbLeaveApprovalStatusDashboardCardComponent,
    FbSummaryStatusDasboardCardComponent,
    FbNotificationsDashboardCardComponent,
    FbAnnouncementsDashboardCardComponent,
    FbTeamMembersDashboardCardComponent,
    FbHolidayListDashboardCardComponent,
    FbTableListDashboardCardComponent,
    FbOnboardingChecklistDashboardCardComponent,
    FbComingSoonDashboardCardComponent,
    FbAttendenceDashboardCardComponent,
    FbMultiStepFormComponent,
    FbHorizontalTabComponent,
    FbDashboardQuickAccessComponent,
    FbMarginGrowthCardComponent,
    FbRedirectPopupComponent
  ]
})
export class FbModuleModule { }
